import { post, url, get } from '../../service/ApiDecorator'

class SystemManage {
  // ------------------系统管理--------------
  // 权限管理——查询角色列表
  @url('/common/eos/select/role/query')
  @post
  getRoles() { }
  // 权限管理——获取职位列表
  @url('/center/permissions/queryDutyInfo')
  @post
  getDutys() { }
  // 权限管理——获取权限树
  @url('/center/permissions/get')
  @post
  getPermissions() { }
  // 权限管理——获取当前用户拥有的权限
  @url('/center/permissions/getUserInfo')
  @post
  getPermissionByUser() { }
  // 权限管理——设置权限
  @url('/center/permissions/save')
  @post
  savePermission() { }
  // 权限管理——获取职位列表
  @url('/v3/duty/listOrgDuty')
  @get
  listOrgDuty() { }

  // 权限菜单
  // 获取当前用户拥有的权限菜单
  @url('/center/permissions/getMyPermissions')
  @post
  getUserAccess() { }
  // 获取当前用户拥有的权限,匹配菜单按钮是否显示
  @url('/center/permissions/getUserInfo')
  @post
  getUserAccessButton() { }
  // 获取系统角色
  @url('/v3/sysRole/listRoleByType')
  @post
  listRoleByType() { }

  // 获取系统已设置权限（人员类型、职位、角色）
  @url('/center/permissions/getStat')
  @post
  getPermissionStat() { }
}

export default new SystemManage()
